import { demandSupplyAPI, keyInsightApi } from "Samarth Module/api/api";
import { aglieDemandAPI, agileKeyInsightApi } from "Samarth Module/api/mdApi";

// Helper function to format date from yyyy-mm-dd to dd-mm-yyyy (handles single dates and ranges)
const formatDate = (dateString) => {
  if (!dateString) return '';
  
  // Check if it's a date range (yyyy-mm-dd to yyyy-mm-dd)
  if (dateString.includes(' to ')) {
    const [startDate, endDate] = dateString.split(' to ').map(date => date.trim());
    const [startYear, startMonth, startDay] = startDate.split('-');
    const [endYear, endMonth, endDay] = endDate.split('-');
    return `${startDay}-${startMonth}-${startYear} to ${endDay}-${endMonth}-${endYear}`;
  }
  
  // Single date format
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

export const ALERT_CONFIG = {
  'RMPM Alert': {
    menuSections: [
      {
        title: "Alerts Insights",
        items: ["Demand supply gap", "Impacted CBUs"],
      },
      {
        title: "Recomm. Insights",
        items: ["Inbound supply status", "Contract status for existing PR", "Quality clearance status", "Alt site excess inventory", "Alternate vendor status"],
      },
      {
        title: "Agentic Insights",
        items: ["Real time update"],
      }

    ],
    apiHandlers: {
      fetchDemandData: (alertDetails) => demandSupplyAPI(alertDetails["Alert ID"]),
      fetchInsightData: (alertDetails) =>
        keyInsightApi(
          alertDetails["Material Id"],
          alertDetails["Site code"],
          alertDetails["Week"].replaceAll(/\D/g, ""),
          alertDetails["Alert ID"]
        )
    },
    getHeaderDetails: (alertDetails) => {
      const headerDetails = {
        "Material ID": alertDetails["Material Id"],
        "Material Description": alertDetails["Material description"]
      };
      
      if (alertDetails["Delivery date"]) {
        headerDetails["Delivery date"] = formatDate(alertDetails["Delivery date"]);
      }
      
      if (alertDetails["Action date"]) {
        headerDetails["Action date"] = formatDate(alertDetails["Action date"]);
      }
      
      return headerDetails;
    }
  },
  'Agile OR': {
    menuSections: [
      {
        title: "Alerts Insights",
        items: ["Agile OR Summary", "WTG Capacity View", "OR trend", "OEE Insights"],
      },
      {
        title: "Recomm. Insights",
        items: ["Projected OR", "Low Priority CBU", "Planned maintenance", "Alternate site"],
      }
    ],
    apiHandlers: {
      fetchDemandData: (alertDetails) => aglieDemandAPI(
        alertDetails["Alert ID"],
        alertDetails["CBU code"],
        alertDetails["Site code"],
        alertDetails["Week"]
      ),
      fetchInsightData: (alertDetails) =>
        agileKeyInsightApi(
          alertDetails["CBU code"],
          alertDetails["Site code"],
          alertDetails["CBU description"] || '',
          alertDetails["Alert ID"],
          alertDetails["Week"],
          alertDetails["Format"]
        )
    },
    getHeaderDetails: (alertDetails) => {
      const headerDetails = {
        "CBU code": alertDetails["CBU code"],
        "CBU description": alertDetails["CBU description"] || ''
      };
      
      if (alertDetails["Delivery date"]) {
        headerDetails["Delivery date"] = formatDate(alertDetails["Delivery date"]);
      }
      
      if (alertDetails["Action date"]) {
        headerDetails["Action date"] = formatDate(alertDetails["Action date"]);
      }
      
      return headerDetails;
    }
  }
};

export const INSIGHT_TEMPLATE = {
  "Impacted CBUs": "Graphical insight gives details of all CBU which are under stress due to demand / supply gap of Material ID : {materialID}",
  "Demand supply gap": "Table / Graph gives details of RMPM Demand & Supply at day / week level for Material ID : {materialID}",
  "Inbound supply status": "Table gives details of Open / Past due POs (if any) for Material ID : {materialID} in Today - 180 days",
  "Alternate vendor status": "Table / Graph gives information about the vendors available in own (alert) plant as well as in (if any) HUL plants for Material ID : {materialID}",
  "Alt site excess inventory": "Table / Graph gives details of on hand & excess stock for Material ID : {materialID} present in own (alert) plant as well as in other (if any) HUL plants.",
  "Contract status for existing PR": "Table gives insight about the as-is scenario for contract details for PR to be released (if any) in current PR release week for Material ID : {materialID}",
  "Quality clearance status": "Table gives information about Material ID : {materialID} rejected or still in quality inspection for Today-7 days (if any)",
  "Real Time update": "Table / Graph gives information about the vendors available in own (alert) plant as well as in (if any) HUL plants for Material ID : {materialID}",
};